var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { GridStateContext } from '../Grid';
import { DataGridCell, CompactCell } from './Cell.styles';
function getCellType(_a) {
    var type = _a.type;
    switch (type) {
        case 'dense':
            return CompactCell;
        default:
            return DataGridCell;
    }
}
export var Cell = React.memo(function (props) {
    var cellProps = React.useContext(GridStateContext).cellProps;
    var finalProps = __assign(__assign({}, cellProps), props);
    var Cell = getCellType(finalProps);
    return (React.createElement(Cell, __assign({}, finalProps),
        React.createElement("span", { className: "DataGrid-CellWrapper" }, props.children)));
});
Cell.displayName = 'Cell';
//# sourceMappingURL=index.js.map